// extracted by mini-css-extract-plugin
export default {"statusText":"RpEXFN"};